import { render, staticRenderFns } from "./surveyGroupsQuestions.vue?vue&type=template&id=3c777e70&"
import script from "./surveyGroupsQuestions.vue?vue&type=script&lang=js&"
export * from "./surveyGroupsQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports